import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, FormGroup, Label, Row, Col, Container, InputGroup, InputGroupText } from 'reactstrap';
import { ControlPoint, CloseOutlined } from '@mui/icons-material';
import moment from 'moment';

import { symbolPriceFormatter } from '~/helpers/price';
import { PedidoContext } from '~/context/PedidoContext';

import { color } from '~/assets/styles/colors';
import ReactGA from 'react-ga4';
import { LoaderMini, LoaderLista } from '../../Loaders';

import {
	ModalFooterCss,
	Title,
	InputDescriptionCss,
	InputCss,
	ButtonCss,
	ModalBodyCss,
	TextStatus,
	ButtonAdd,
} from './styles';

export function ModalVisualizar(props) {
	const { user } = useSelector((state) => state.auth);
	const { toggle, numPedido, tipo, setToggle, idPedido, setAtualizaNF, statusNotas } = props;
	const { getPedidoIndividual, getNotas, inserirNotas } = useContext(PedidoContext);
	const [loading, setLoading] = useState(true);
	const [notasFiscais, setNotasFiscais] = useState([])
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		if (toggle) {
			setNotasFiscais([]);
			getNotas(idPedido);
			getPedidoIndividual(idPedido.toString(), tipo).then((res) => {
				setCampos(res.data.pedido);
				if (res.data.pedido.nota_fiscal.length > 0) {
					setNotasFiscais(res.data.pedido.nota_fiscal[0].notas.notas);
				}
				verificaSeNotaFoiEnviada(res.data.pedido.nota_fiscal)
				setLoading(false)
			});
			setLoading(true)
		}

	}, [toggle]);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const [campos, setCampos] = useState({
		id: '',
		nome_destinatario: '',
		nome: '',
		documento: '',
		data_pedido: '',
		contato: '',
		descricao: '',
		nota_fiscal: [],
		valor_pedido: 0,
		status: 'pendente',
	});

	const handleFormChange = (index, event) => {
		const data = [...notasFiscais];
		data[index] = event.target.value;
		setNotasFiscais(data);
	}

	const addNotas = () => {
		const newfield = ''
		setNotasFiscais([...notasFiscais, newfield])
		handleClickAddNotaGA4();
	}

	const removeNotas = (index) => {
		const data = [...notasFiscais];
		data.splice(index, 1)
		setNotasFiscais(data)
	}

	const handleSaveNotas = (enviadoState) => {
		if (notasFiscais[0]) {
			inserirNotas(campos.id, notasFiscais, enviadoState).then(() => {
				setToggle(false)
				setNotasFiscais([])
				setAtualizaNF('mudou')
			})
		}
	}

	function renderColor(statusGeral, statusNota) {
		if (statusGeral === 'reprovado') {
			return color.red;
		}
		if (statusGeral === 'pendente') {
			return color.yellow;
		}
		switch (statusNota) {
			case 'Concluído':
				return color.green;
			case 'NF Pendente':
				return color.orange;
			case 'NF Enviada':
				return color.orange;
			case 'Aguardando NF':
				return color.orange;
			case 'NF Recebida':
				return color.orange;
			case 'Pendente':
				return color.yellow;
			case 'Reprovado':
				return color.red;
			case 'pendentesalvar':
				return color.yello
			default:
				return 'Null';
		}
	}

	function verificaSeNotaFoiEnviada(nf) {
		if (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria') {
			if ((nf.length === 0 || nf.length > 0) && (nf[0] ? nf[0].status_nota_pedido === 'PENDENTE' : false)) {
				return 'pendente'
			} if ((nf.length === 0 || nf.length > 0) && (nf[0] ? nf[0].status_nota_pedido === 'PENDENTESALVAR' : false)) {
				return 'pendenteSalvar'
			} if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'ENVIADO' : false)) {
				return 'enviado'
			} if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'CONCLUIDO' : false)) {
				return 'concluido'
			}
		}
		if (user.dados.cargo.toLowerCase() === '') {
			if ((nf.length === 0 || nf.length > 0) && (nf[0] ? nf[0].status_nota_pedido === 'PENDENTE' : false)) {
				return 'pendente'
			} if ((nf.length === 0 || nf.length > 0) && (nf[0] ? nf[0].status_nota_pedido === 'PENDENTESALVAR' : false)) {
				return 'pendenteSalvar'
			} if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'ENVIADO' : false)) {
				return 'recebido'
			} if (nf.length > 0 && (nf[0] ? nf[0].status_nota_pedido === 'CONCLUIDO' : false)) {
				return 'concluido'
			}
		}
		return 'pendente'
	}

	function handleClickSalvarGA4() {
		ReactGA.event({
			category: "salvar_conluir_pedido",
			action: "Salvar Pedido",
			label: "Salvando Pedido",
		});
	}

	function handleClickSalvarEConcluirGA4() {
		ReactGA.event({
			category: "salvar_conluir_pedido",
			action: "Salvar e Concluir Pedido",
			label: "Salvando e Concluindo Pedido",
		});
	}

	function handleClickAddNotaGA4() {
		ReactGA.event({
			category: "add_nota_click",
			action: "Adiciona Nota Fiscal",
			label: "Adicionando Nota Fiscal",
		});
	}

	return (
		<>
			<Modal
				isOpen={toggle}
				size="xl"
				style={{ maxWidth: 1200, width: '100%' }}>
				<Title className="d-flex align-items-center justify-content-between">
					Ordem de Pagamento ID Nº #
					{numPedido || <LoaderMini />}
					<ButtonCss
						style={{
							borderRadius: 0,
							backgroundColor: '#D3FBE1',
							border: `1px solid #D3FBE1`,
						}}
						className="d-flex align-items-center justify-content-center"
						onClick={() => {
							verificaSeNotaFoiEnviada(campos.nota_fiscal) === 'recebido' && handleSaveNotas('CONCLUIDO')
							setToggle(false);
							setNotasFiscais([])
						}}>
						<CloseOutlined />
					</ButtonCss>
				</Title>
				{loading ?
					<LoaderLista />
					:
					<>
						<ModalBodyCss>
							<Container xs="12" md="12" lg="12">
								<Row xs="12" md="12" lg="12">
									<Col xs="12" md="12" lg="5">
										<FormGroup>
											<Label>{tipo === 'solicitados' ? 'Destinatário' : 'Solicitante'}</Label>
											<InputCss
												disabled
												value={tipo === 'solicitados' ? campos.nome_destinatario : campos.nome}
											/>
										</FormGroup>
									</Col>
									<Col xs="6" md="6" lg="4">
										<FormGroup>
											{isMobile ? <Label>Nº Refêrencia</Label> : <Label>Nº Refêrencia do Pedido</Label>}
											<InputCss
												disabled
												value={numPedido}
											/>
										</FormGroup>
									</Col>
									<Col xs="6" md="6" lg="3">
										<FormGroup>
											<Label>Valor do Pedido</Label>
											<InputCss
												disabled
												value={symbolPriceFormatter(campos.valor_pedido)}
											/>
										</FormGroup>
									</Col>

									{campos.status.toLowerCase() === 'reprovado' &&
										<Col xs="12" md="6" lg="10" style={{ paddingRight: 0 }}>
											<Row>
												<Col xs="6" md="12" lg="12">
													<FormGroup>
														<Label>Nº Nota Fiscal</Label>
														<InputCss
															style={{ textAlign: 'center' }}
															name='nota'
															disabled
															value='Esse pedido foi reprovado.'
														/>
													</FormGroup>
												</Col>
											</Row>
										</Col>
									}
									{campos.status.toLowerCase() === 'pendente' &&
										<Col xs="12" md="6" lg="10" style={{ paddingRight: 0 }}>
											<Row>
												<Col xs="6" md="12" lg="12">
													<FormGroup>
														<Label>Nº Nota Fiscal</Label>
														<InputCss
															style={{ textAlign: 'center' }}
															name='nota'
															disabled
															value='Esse pedido está pendente.'
														/>
													</FormGroup>
												</Col>
											</Row>
										</Col>
									}

									{/* Após aprovação do distribuidor */}
									{campos.status.toLowerCase() === 'aprovado' &&
										<>
											{/* Pendente sem notas */}
											{(verificaSeNotaFoiEnviada(campos.nota_fiscal)) === 'pendente' &&
												<Col xs="12" md="6" lg="10">
													{user.dados.cargo.toLowerCase() === '' ?
														<Row>
															<Col xs="6" md="12" lg="12">
																<FormGroup>
																	<Label>Nº Nota Fiscal</Label>
																	<InputCss
																		style={{ textAlign: 'center' }}
																		name='nota'
																		disabled
																		value='Esse pedido está com nota fiscal pendente.'
																	/>
																</FormGroup>
															</Col>
														</Row>
														:
														<Row>
															{notasFiscais.map((input, index) => (
																<Col key={index} xs="6" md="6" lg="4">
																	<Label key={index} style={{ color: index >= 1 ? 'white' : 'black' }}>Nº Nota Fiscal</Label>
																	<InputGroup>
																		<InputCss
																			name='nota'
																			onChange={e => handleFormChange(index, e)}
																			value={input}
																		/>
																		<InputGroupText style={{ backgroundColor: '#fff', borderLeft: 0, borderRadius: 0 }}>
																			<button
																				style={{ border: '0px', backgroundColor: '#fff' }}
																				type='button'
																				onClick={() => removeNotas(index)}>
																				<CloseOutlined />
																			</button>
																		</InputGroupText>
																	</InputGroup>
																</Col>
															))}
															<>
																<Col xs="6" md="6" lg="4">
																	<Label style={{ color: notasFiscais.length > 0 ? 'white' : 'black', onselectstart: false, marginBottom: 0 }}>Nº Nota Fiscal</Label>
																	<ButtonAdd onClick={addNotas}>
																		<ControlPoint />
																	</ButtonAdd>
																</Col>
															</>
														</Row>
													}
												</Col>
											}

											{/* Pendente com notas para distribuidor */}
											{((verificaSeNotaFoiEnviada(campos.nota_fiscal)) === 'pendenteSalvar' && user.dados.cargo !== '') &&
												<Col xs="12" md="6" lg="10">
													<Row>
														{notasFiscais.map((input, index) => (
															<>
																<Col key={index} xs="6" md="6" lg="4">
																	<Label key={index} style={{ color: index >= 1 ? 'white' : 'black' }}>Nº Nota Fiscal</Label>
																	<InputGroup>
																		<InputCss
																			name='nota'
																			onChange={e => handleFormChange(index, e)}
																			value={input}
																		/>
																		<InputGroupText style={{ backgroundColor: '#fff', borderLeft: 0, borderRadius: 0 }}>
																			<button
																				style={{ border: '0px', backgroundColor: '#fff' }}
																				type='button'
																				onClick={() => removeNotas(index)}>
																				<CloseOutlined />
																			</button>
																		</InputGroupText>
																	</InputGroup>
																</Col>
															</>
														))}
														<>
															<Col xs="12" md="6" lg="4">
																<Label style={{ color: 'white', onselectstart: false, marginBottom: 0 }}>Nº Nota Fiscal</Label>
																<ButtonAdd onClick={addNotas}>
																	<ControlPoint />
																</ButtonAdd>
															</Col>
														</>
													</Row>
												</Col>
											}

											{/* Pendente com notas para revenda */}
											{((verificaSeNotaFoiEnviada(campos.nota_fiscal)) === 'pendenteSalvar' && user.dados.cargo === '') &&
												<Col xs="12" md="6" lg="10">
													<Row>
														{notasFiscais.map((input, index) => (
															<>
																<Col key={index} xs="6" md="6" lg="4">
																	<FormGroup>
																		<Label key={index} style={{ color: index >= 1 ? 'white' : 'black' }}>Nº Nota Fiscal</Label>
																		<InputCss
																			name='nota'
																			value={input}
																		/>
																	</FormGroup>
																</Col>
															</>
														))}
													</Row>
												</Col>
											}

											{/* Concluido */}
											{((verificaSeNotaFoiEnviada(campos.nota_fiscal)) === 'concluido' || (verificaSeNotaFoiEnviada(campos.nota_fiscal)) === 'recebido' || (verificaSeNotaFoiEnviada(campos.nota_fiscal)) === 'enviado') &&
												<Col xs="12" md="6" lg="10">
													<Row>
														{notasFiscais.map((input, index) => (
															<>
																<Col key={index} xs="6" md="6" lg="4">
																	<FormGroup>
																		<Label key={index} style={{ color: index >= 1 ? 'white' : 'black' }}>Nº Nota Fiscal</Label>
																		<InputCss
																			name='nota'
																			value={input}
																		/>
																	</FormGroup>
																</Col>
															</>
														))}
													</Row>
												</Col>
											}
										</>
									}
									<Col style={{ textAlign: 'right' }} xs="12" md="6" lg="2">
										<FormGroup>
											<Label>Status</Label>
											<div>
												<TextStatus style={{
													fontSize: '16px',
													color: renderColor(campos.status.toLowerCase(), statusNotas),
												}}>
													{campos.status.toLowerCase() === 'pendente' ? 'Pendente' :
														<>
															{campos.status.toLowerCase() === 'reprovado' ? 'Reprovado' : statusNotas}
														</>
													}
												</TextStatus>
												<TextStatus style={{
													fontSize: '16px',
													color: renderColor(campos.status.toLowerCase(), statusNotas),
												}}>
													{`${moment(campos.data_pedido, 'YYYY/MM/DD').format('MMM').charAt(0).toUpperCase() + moment(campos.data_pedido, 'YYYY/MM/DD').format('MMM').toLowerCase().slice(1)}/${moment(campos.data_pedido, 'YYYY/MM/DD').format('YYYY')}`}
												</TextStatus>
											</div>
										</FormGroup>
									</Col>
								</Row>

								<FormGroup>
									<Label>Descrição do pedido</Label>
									<InputDescriptionCss
										type="textarea"
										name="descricao"
										value={campos.descricao}
										disabled
									/>
								</FormGroup>
							</Container>
						</ModalBodyCss>
						<ModalFooterCss>
							{((verificaSeNotaFoiEnviada(campos.nota_fiscal) === 'pendente'
								|| verificaSeNotaFoiEnviada(campos.nota_fiscal) === 'pendenteSalvar')
								&& (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria')
								&& campos.status.toLowerCase() !== 'pendente'
								&& campos.status.toLowerCase() !== 'reprovado') &&
								<ButtonCss
									style={{
										padding: `${isMobile && '14px 4% 14px 4%'}`,
										backgroundColor: color.primary,
										border: '1px solid #4A4A49',
									}}
									size="sm"
									onClick={() => {
										handleSaveNotas('ENVIADO')
										handleClickSalvarEConcluirGA4()
									}}>
									SALVAR E CONCLUIR
								</ButtonCss>
							}
							{(campos.status.toLowerCase() !== 'pendente'
								&& campos.status.toLowerCase() !== 'reprovado'
								&& (verificaSeNotaFoiEnviada(campos.nota_fiscal) === 'pendente' || verificaSeNotaFoiEnviada(campos.nota_fiscal) === 'pendenteSalvar')
								&& (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria')) &&
								<ButtonCss
									style={{
										padding: `${isMobile && '14px 4% 14px 4%'}`,
										backgroundColor: color.primary,
										border: '1px solid #4A4A49',
									}}
									size="sm"
									onClick={() => {
										handleSaveNotas('PENDENTESALVAR')
										handleClickSalvarGA4()
									}}>
									SALVAR
								</ButtonCss>
							}

							<ButtonCss
								style={{
									padding: `${isMobile && '14px 4% 14px 4%'}`,
									backgroundColor: color.primary,
									border: '1px solid #4A4A49',
								}}
								size="sm"
								onClick={() => {
									verificaSeNotaFoiEnviada(campos.nota_fiscal) === 'recebido' && handleSaveNotas('CONCLUIDO')
									setToggle(false);
									setNotasFiscais([])
								}}>
								FECHAR
							</ButtonCss>
						</ModalFooterCss>

					</>
				}
			</Modal>

		</>
	);
}
